<template>
  <div>
    <div
      v-show="showableSearchForm"
      class="item-index-cover"
      @click="hideSearchForm"
    />
    <transition name="slide">
      <SearchFormDetail
        v-if="showableSearchForm"
        :higher-budget="higherBudget"
        :lower-budget="lowerBudget"
        :categories="categories"
        :scenes="scenes"
        :receiving-kinds="receivingKinds"
        :selected-category-id="selectedCategoryId"
        :selected-scene-id="selectedSceneId"
        :selected-receiving-kind-id="selectedReceivingKindId"
        @submit="onSubmit"
        @click-hide="hideSearchForm"
      />
    </transition>
  </div>
</template>
<script>
import SearchFormDetail from './SearchFormDetail'
export default {
  components: {
    SearchFormDetail
  },
  props: {
    showableSearchForm: {
      type: Boolean,
      required: true
    },
    lowerBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    higherBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    categories: {
      type: Array,
      required: true
    },
    selectedCategoryId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    scenes: {
      type: Array,
      required: true
    },
    selectedSceneId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    receivingKinds: {
      type: Array,
      required: true
    },
    selectedReceivingKindId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  methods: {
    hideSearchForm() {
      this.$emit('hide')
    },
    onSubmit(
      inputtedLowerBudget,
      inputtedHigherBudget,
      inputtedSelectedCategoryId,
      inputtedSelectedSceneId,
      inputtedReceivingKindId
    ) {
      this.$emit(
        'submit',
        inputtedLowerBudget,
        inputtedHigherBudget,
        inputtedSelectedCategoryId,
        inputtedSelectedSceneId,
        inputtedReceivingKindId
      )
    }
  }
}
</script>
